import React from "react";
import { useNavigate } from "react-router-dom";

import { Avatar, Button, CardTitle, Stack } from "@/components/ui";
import { type Card as StatusCard } from "@/schemas";

interface GroupLinkPreviewProps {
  card: StatusCard;
}

const GroupLinkPreview: React.FC<GroupLinkPreviewProps> = ({ card }) => {
  const navigate = useNavigate();

  const { group } = card;
  if (!group) return null;

  const navigateToGroup = () => navigate(`/group/${group.slug}`);

  return (
    <Stack className="cursor-default overflow-hidden rounded-lg border text-center">
      <div
        className="-mb-8 h-32 w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${group.header_static})` }}
      />

      <Avatar
        className="mx-auto border-4 border-background"
        src={group.avatar_static}
        size={64}
      />

      <Stack space={4} className="p-4">
        <CardTitle
          title={
            <span
              dangerouslySetInnerHTML={{ __html: group.display_name_html }}
            />
          }
        />

        <Button variant="default" onClick={navigateToGroup} block>
          View Group
        </Button>
      </Stack>
    </Stack>
  );
};

export { GroupLinkPreview };
